import * as hbApp from '@app/hb-app'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import {
  actionCreators,
  FeedbackType,
  IFeedbackState,
} from '../modules/feedback'
import './FeedbackButton.scss'

interface IFeedbackButtonUIProps {
  className?: string
  style?: React.CSSProperties
}

type FeedbackButtonProps = IFeedbackButtonUIProps &
  IFeedbackState &
  typeof actionCreators

export class FeedbackButton extends React.PureComponent<FeedbackButtonProps> {
  constructor(props: FeedbackButtonProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <span>
        <a
          className={this.props.className}
          id='feedback'
          onClick={this._showDialog}
          style={this.props.style}
          title='Feedback'
        >
          <FontAwesomeIcon icon={['fal', 'smile']} fixedWidth size='lg' />
          {this._renderModal()}
        </a>
      </span>
    )
  }

  private _closeDialog() {
    this.props.closeDialog()
  }

  private _onChangeText(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setFeedbackText(event.target.value)
  }

  private _onChangeType(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setFeedbackType(event.target.value as FeedbackType)
  }

  private _renderModal() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this._closeDialog}>
        <ModalHeader toggle={this._closeDialog}>Send Feedback</ModalHeader>
        <Form onSubmit={this._submitFeedback}>
          <ModalBody>
            <FormGroup>
              <Label for='feedbackType'>Type</Label>
              <Input
                type='select'
                id='feedbackType'
                name='feedbackType'
                onChange={this._onChangeType}
                value={this.props.feedbackType}
              >
                <option value={FeedbackType.Bug}>Bug</option>
                <option value={FeedbackType.Enhancement}>
                  Feature Request
                </option>
                <option value={FeedbackType.Visual}>Visual Issue</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for='feedbackText'>Description</Label>
              <Input
                type='textarea'
                id='feedbackText'
                name='feedbackText'
                onChange={this._onChangeText}
                value={this.props.feedbackText}
              />
            </FormGroup>
            <div>
              <Label>Version</Label> {hbApp.version} ({hbApp.commit})
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' outline onClick={this._closeDialog}>
              <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
            </Button>
            <Button
              color='primary'
              type='submit'
              disabled={this.props.isSaving}
            >
              <FontAwesomeIcon icon={['fal', 'paper-plane']} fixedWidth /> Send
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }

  private _showDialog() {
    this.props.showDialog()
  }

  private _submitFeedback(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    this.props.submitFeedback(this.props.feedbackType, this.props.feedbackText)
  }
}
